import React, { useState } from 'react';
import { SystemLog } from '../types/costwand';
import { useSystemLogs } from '../hooks/useSystemLogs.ts';
import SystemLogTable from '../components/SystemLogTable.tsx';
import SystemLogDetailsDialog from '../components/SystemLogDetailsDialog.tsx';
import {
  Dialog,
  DialogTrigger, // Keep DialogTrigger if you want to open the dialog from a button outside the table
} from '../components/ui/dialog.tsx';

const SystemLogPage: React.FC = () => {
  const {
    systemLogs,
    loading,
    error,
    currentPage,
    totalPages,
    totalItems,
    handlePageChange,
  } = useSystemLogs();

  const [isDetailsDialogOpen, setIsDetailsDialogOpen] = useState<boolean>(false);
  const [selectedLogEntry, setSelectedLogEntry] = useState<SystemLog | null>(null);

  const handleViewDetails = (log: SystemLog) => {
    setSelectedLogEntry(log);
    setIsDetailsDialogOpen(true);
  };

  const handleCloseDetailsDialog = () => {
    setIsDetailsDialogOpen(false);
    setSelectedLogEntry(null);
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-secondary-foreground">System Log</h2>
      </div>

      <SystemLogTable
        systemLogs={systemLogs}
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        onViewDetails={handleViewDetails}
        loading={loading}
        error={error}
        baseEndpoint="/system_log" // NEW: Pass the base endpoint
      />

      <Dialog open={isDetailsDialogOpen} onOpenChange={handleCloseDetailsDialog}>
        {/* DialogTrigger is not strictly necessary here if the dialog is opened programmatically */}
        {/* <DialogTrigger asChild>
          <Button variant="outline">Open Details</Button>
        </DialogTrigger> */}
        <SystemLogDetailsDialog logEntry={selectedLogEntry} />
      </Dialog>
    </div>
  );
};

export default SystemLogPage;